import type { Address } from "@/services/addresses/addressTypes";
import type { CartItem_Schema, CartItemId_Schema, ShoppingCart_Schema, SingleSellerCart_Schema } from "@/services/marketplace/cart/cartSchema";
import type { PaymentMethod } from "@/services/marketplace/paymentMethod/paymentMethodTypes";
import type { ShippingMethod } from "@/services/marketplace/shippingMethod/shippingMethodTypes";
import type { z } from "zod";

export type ShoppingCart = z.infer<typeof ShoppingCart_Schema>;

export type SingleSellerCart = z.infer<typeof SingleSellerCart_Schema>;

export type CartItemId = z.infer<typeof CartItemId_Schema>;

export type CartItem = z.infer<typeof CartItem_Schema>;

export type ShoppingCart_WithSelectedShippingMethod = ShoppingCart & {
  selectedShippingMethod: ShippingMethod;
};

export type ShoppingCart_WithSelectedPaymentMethod = ShoppingCart & {
  selectedPaymentMethod: PaymentMethod;
};

export type ShoppingCart_WithShippingAddress = ShoppingCart & {
  shippingAddress: Address;
};

export enum CartStatus {
  Empty,
  NotEmpty,
}
